export default "__VITE_ASSET__MPAlIBpt__"